export const DEVICE_STATUS_ACTIVE = 'active';
export const DEVICE_STATUS_PROVISIONED = 'provisioned';
export const DEVICE_STATUS_HIDDEN = 'hidden';

export const DEVICE_STATUS_TABS = [
  { value: DEVICE_STATUS_ACTIVE, label: 'Active' },
  { value: DEVICE_STATUS_PROVISIONED, label: 'Provisioned' },
  { value: DEVICE_STATUS_HIDDEN, label: 'Archived' },
] as const;

export type DeviceStatusTabValue = (typeof DEVICE_STATUS_TABS)[number]['value'];
